import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Layout from './Layout';

const PrivateRoute = ({ children }) => {
  const { user, token, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!token || !user) {
    // replace, not push: otherwise every bounce back through a protected
    // route (e.g. the hardware back button walking through history after a
    // logout) pushes ANOTHER /auth entry on top instead of shrinking the
    // stack, so canGoBack never reaches false and the native back button
    // gets stuck looping in place (see App.js's BackExitGuard).
    return <Navigate to="/auth" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default PrivateRoute; 